module.exports = __webpack_public_path__ + "registration-form-ca2d4608/background-96bf11140742e9ad659d134d2b791492.png";